/**
 * What a <Field> (components/ui.jsx) tells the control inside it: the id of the hint or
 * error drawn under it, for the control's aria-describedby, and whether that is an error.
 *
 * A module of its own because both ui.jsx and Select.jsx need it, and ui.jsx already
 * imports from Select.jsx. A plain <input>, <textarea> or <select> written directly inside
 * a Field is wired by the Field itself; a component — the pickers, DateField, Switch —
 * reads this, since only it knows which of its elements is the one that takes focus.
 */
import { createContext, useContext } from 'react'

export const FieldContext = createContext({ describedBy: undefined, invalid: false })

export const useFieldDescription = () => useContext(FieldContext)

/** Two aria-describedby lists as one, either of them possibly empty. */
export const joinIds = (...ids) => ids.filter(Boolean).join(' ') || undefined
